
import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

const useStyles = createUseStyles({
  subContainerContrat: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minWidth: 0,
    borderRadius: "10px",
    padding: 10,
    gap: "15px",
    backgroundColor: colors.surfaceElevated,
    border: `1px solid ${colors.borderLight}`,
    "& > div": {
      flex: 1,
      padding: "0px 10px 10px 10px",
    },
  },
  flexParent: {
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    "& > div": {
      flex: 1,
      minWidth: 0,
    },
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      gap: "16px",
    },
  },
  containerContrat: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    gap: "13px",
  },
  buttonEdit: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "10px 10px 0px 0px",
    padding: "0px !important",
  },
});

export default useStyles;
